import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const InquiryModal = ({ isOpen, toggle, onSubmit }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [noOfPeople, setNoOfPeople] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [errors, setErrors] = useState({});

  const customerTypeOptions = [
    { value: "bachelors", label: "Bachelors (boys group)" },
    { value: "girlsGroup", label: "Girls group" },
    { value: "couples", label: "Couples" },
    { value: "corporate", label: "Corporate" },
    { value: "family", label: "Family" }
  ];

  // Utility: get today's date in YYYY-MM-DD
  const getTodayKey = () => {
    return new Date().toISOString().split("T")[0];
  };

  // Prefill if user is in localStorage
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData) {
      setName(userData.name || "");
      setEmail(userData.email || "");
      setContact(userData.contact || "");
    }
  }, [isOpen]);

  const getMidnightTimestamp = () => {
    const now = new Date();
    now.setHours(23, 59, 59, 999); // Today at 24:00 == midnight
    return now.getTime();
  };

  // Validate fields
  const validate = () => {
    const newErrors = {};
    if (!name) newErrors.name = true;
    if (!email) newErrors.email = true;
    if (!contact) newErrors.contact = true;
    if (!noOfPeople) newErrors.noOfPeople = true;
    if (!customerType) newErrors.customerType = true;
    if (!startDate) newErrors.startDate = true;
    if (!endDate) newErrors.endDate = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    console.log("This is Calling");
    if (!validate()) return;

    const payload = {
      name,
      email,
      contact,
      noOfPeople,
      customerType,
      startDate,
      endDate
    };

    // Save today's enquiry
    const todayKey = getTodayKey();
    // localStorage.setItem(`enquiry_${todayKey}`, JSON.stringify(payload));

    localStorage.setItem(
      "commonEnquiryData",
      JSON.stringify({
        data: payload,
        expiresAt: getMidnightTimestamp()
      })
    );

    // Notify parent
    onSubmit(payload);

    // Optionally close modal
    toggle();
  };

  const getInputClass = (field) => (errors[field] ? "error-input" : "");

  return (
    <Modal style={{zIndex:'10000'}} size="md" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Inquiry Form</ModalHeader>
      <ModalBody>
        <div className="modal-div">
          
          <input
            type="text"
            className={getInputClass("name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Your Name"
          />
          {errors.name && <p className="error-text">Name is required</p>}

         
          <input
            type="email"
            className={getInputClass("email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Your Email"
          />
          {errors.email && <p className="error-text">Email is required</p>}

          
          <input
            type="text"
            className={getInputClass("contact")}
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            placeholder="Enter Your Contact Number"
          />
          {errors.contact && (
            <p className="error-text">Contact number is required</p>
          )}

          
          <input
            type="number"
            className={getInputClass("noOfPeople")}
            value={noOfPeople}
            onChange={(e) => setNoOfPeople(e.target.value)}
            placeholder="Enter Number of People"
            min="1"
          />
          {errors.noOfPeople && (
            <p className="error-text">Please enter number of people</p>
          )}

         
          <select
            className={getInputClass("customerType")}
            value={customerType}
            onChange={(e) => setCustomerType(e.target.value)}
          >
            <option value="" disabled>
              Select Customer Type
            </option>
            {customerTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {errors.customerType && (
            <p className="error-text">Customer type is required</p>
          )}

         
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            minDate={new Date()}
            placeholderText="Select Start Date"
            className={getInputClass("startDate")}
          />
          {errors.startDate && (
            <p className="error-text">Check-in date is required</p>
          )}

         
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText="Select End Date"
            className={getInputClass("endDate")}
          />
          {errors.endDate && (
            <p className="error-text">Check-out date is required</p>
          )}

          <br />
          <button onClick={handleSubmit}>Submit Inquiry</button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default InquiryModal;
